import { FC, useEffect, useMemo, useState } from 'react';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from '../../../components/Text';
import { COLORS, FONTS } from '../../../constants';
import { Loading } from '../../../components';
import DropDownSelect from '../../../components/DropDownSelect';
import { ActivityTabItem } from './Activities';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import MonthSwitcher from '../../../components/MonthSwitcher/MonthSwitcher';
import InputDatePicker from '../../../components/InputDatePicker/InputDatePicker';
import { IActivity, IActivityType } from '../../../types/activities.types';
import dayjs from 'dayjs';
import { IFormData } from '../../../components/FormHelper/FormHelper.types';
import ActivityApi from '../../../services/api/activity.api';
import { Button } from '../../../components/Button';
import { NavigationService } from '../../../services/navigation';
import { isSameDate } from '../../../services/utils/dateConvert';
import { DropDownItem } from '../../../models/DropDownItem';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import { DATE_TYPE } from '../../../constants/activity';
import { convertToAmPm } from '../../../services/utils';

// const activityTypes = [
//   {
//     label: 'Individual',
//     value: 'Individual',
//   },
// ];

const ActivityItem: FC<{ index: number; activity: IActivity }> = ({
  index,
  activity,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={[
        {
          flexDirection: 'row',
          marginBottom: 40,
        },
        isDesktop()
          ? {
              width: '50%',
            }
          : {},
      ]}
    >
      <View
        style={[
          {
            width: '100%',
          },
          isDesktop()
            ? {
                paddingHorizontal: 20,
              }
            : {},
        ]}
      >
        <View
          style={{
            flexDirection: 'column',
          }}
        >
          <View style={{ marginBottom: 10 }}>
            <View
              style={{ flexDirection: 'row', justifyContent: 'space-between' }}
            >
              <Text
                style={[
                  {
                    fontFamily: FONTS.AvenirMedium,
                    fontSize: 19,
                    color: COLORS.BLACK,
                    fontWeight: '800',
                    lineHeight: 26,
                    marginBottom: 10,
                  },
                ]}
              >
                {activity.name}
              </Text>
              {activity.date_type.value !== DATE_TYPE.NORMAL ? (
                <Text style={styles.activityTopSubText}>
                  {activity.date_type.name}
                </Text>
              ) : activity.start_date === activity.end_date ? (
                <Text style={styles.activityTopSubText}>
                  {dayjs(new Date(activity.start_date)).format('D MMMM YYYY')}
                </Text>
              ) : (
                <></>
              )}
            </View>
            <View
              style={{
                height: 2,
                width: 58,
                backgroundColor: COLORS.RED_PRIMARY,
                marginBottom: 10,
              }}
            ></View>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <View>
                {activity.date_type.value === DATE_TYPE.NORMAL &&
                  activity.start_date !== activity.end_date && (
                    <>
                      <Text style={styles.activityContentText}>
                        {`Start: ${dayjs(new Date(activity.start_date)).format(
                          'D MMMM YYYY'
                        )}`}
                      </Text>
                      <Text style={styles.activityContentText}>
                        {`End: ${dayjs(new Date(activity.end_date)).format(
                          'D MMMM YYYY'
                        )}`}
                      </Text>
                    </>
                  )}
                <Text style={styles.activityContentText}>{activity.type}</Text>
                <Text style={styles.activityContentText}>{activity.venue}</Text>
              </View>
              <View>
                <View
                  style={{
                    borderRadius: 18,
                    paddingVertical: 5,
                    paddingHorizontal: 13,
                    backgroundColor: COLORS.WHITE,
                    flexDirection: 'row',
                    marginBottom: 10,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: FONTS.AvenirMedium,
                      fontSize: 12,
                      fontWeight: '500',
                      color: COLORS.BLACK,
                      textAlign: 'center',
                      lineHeight: 14,
                    }}
                  >
                    {`${convertToAmPm(activity.start_time)} - ${convertToAmPm(
                      activity.end_time
                    )}`}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          {isDesktop() && (
            <TouchableOpacity
              style={{ marginBottom: 20 }}
              onPress={() => {
                NavigationService.push('Root', {
                  screen: 'MenuTab',
                  params: {
                    screen: 'ActivitiesBookDetail',
                    params: {
                      id: activity.id,
                    },
                  },
                });
              }}
            >
              <Image
                source={
                  activity.image
                    ? {
                        uri: activity.image,
                      }
                    : require('../../../assets/activities-image.png')
                }
                style={[
                  {
                    width: '100%',
                    height: 250,
                    borderRadius: 18,
                  },
                ]}
              />
            </TouchableOpacity>
          )}
          <Button
            onPress={() => {
              NavigationService.push('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'ActivitiesBookDetail',
                  params: {
                    id: activity.id,
                  },
                },
              });
            }}
            text={isDesktop() ? 'SIGN UP' : 'Register Now'}
            arrowRight={false}
            style={[
              {},
              isDesktop()
                ? {
                    paddingVertical: 12,
                  }
                : {
                    paddingHorizontal: 30,
                    borderRadius: 18,
                    paddingVertical: 7,
                    alignSelf: 'flex-start',
                  },
            ]}
            desktopButtonStyle={{
              borderRadius: 18,
            }}
            textStyle={[
              {
                fontFamily: FONTS.AvenirMedium,
              },
              isDesktop()
                ? {
                    fontSize: 19,
                  }
                : {
                    fontSize: 16,
                    fontWeight: '500',
                  },
            ]}
          />
        </View>
      </View>
    </View>
  );
};

export const BookActivities: FC = () => {
  const { user } = useSelector((redux: RootState) => redux.authReducer);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [activityTypes, setActivityTypes] = useState<IActivityType[]>([]);
  const [activityType, setActivityType] = useState<number>();
  const [filterType, setFilterType] = useState<
    'today' | 'this-week' | 'month' | 'date'
  >('today');
  const [filters, setFilters] = useState<IFormData>({
    type: 'today',
  });
  const isDesktop = useIsDesktop();
  const [activityList, setActivityList] = useState<IActivity[]>([]);
  const [filterDate, setFilterDate] = useState<string>(
    dayjs(new Date()).format('YYYY-MM-DD')
  );

  const fetchActivityTypes = async () => {
    ActivityApi.getActivityTypes()
      .then((res) => {
        setActivityTypes(res.data.data);
      })
      .catch((error) => {});
  };

  const fetchActivities = async (filterData: IFormData) => {
    setIsLoading(true);
    ActivityApi.getActivities(filterData)
      .then((res) => {
        setActivityList(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChangeTab = (type: 'today' | 'this-week' | 'month' | 'date') => {
    setFilterType(type);
    setFilters({
      type_id: filters.type_id,
      type: type,
    });
  };

  const handleMonthFilter = (monthDateObj: Date) => {
    const year = monthDateObj.getFullYear();
    const month = monthDateObj.getMonth();
    const now = new Date();

    const start =
      now.getMonth() === month && now.getFullYear() === year
        ? now
        : new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);

    setFilterType('month');
    setFilters({
      type_id: filters.type_id,
      start_time: `${dayjs(start).format('YYYY-MM-DD')} 00:00:00`,
      end_time: `${dayjs(end).format('YYYY-MM-DD')} 23:59:59`,
    });
  };

  const handleDateFilter = (dateString: string) => {
    const date = new Date(dateString);
    setFilterDate(dayjs(date).format('YYYY-MM-DD'));
    setFilterType('date');
    setFilters({
      type_id: filters.type_id,
      start_time: `${dayjs(date).format('YYYY-MM-DD')} 00:00:00`,
      end_time: `${dayjs(date).format('YYYY-MM-DD')} 23:59:59`,
    });
  };

  const activityTypeItems = useMemo(() => {
    const items = activityTypes.map((item, index) => {
      return {
        label: item.name,
        value: item.id,
      };
    });
    return [
      {
        label: 'All',
        value: '',
      },
      ...items,
    ];
  }, [activityTypes]);

  useEffect(() => {
    fetchActivities(filters);
  }, [filters]);

  useEffect(() => {
    fetchActivityTypes();
  }, []);

  return (
    <View
      style={[
        {
          paddingHorizontal: 20,
        },
        isDesktop()
          ? {
              backgroundColor: COLORS.WHITE,
            }
          : {
              backgroundColor: COLORS.LIGHT_RED,
              paddingTop: 20,
            },
      ]}
    >
      <Text
        style={[
          {
            fontFamily: FONTS.Arial,
            color: COLORS.BLACK,
            textTransform: 'uppercase',
            letterSpacing: 2,
          },
          isDesktop()
            ? {
                fontSize: 24,
                fontWeight: '600',
                marginBottom: 30,
              }
            : {
                fontSize: 18,
                fontWeight: '800',
                marginBottom: 15,
              },
        ]}
      >
        {`Book ${user?.type_name} Activities`}
      </Text>
      <View
        style={{ flexDirection: 'row', marginBottom: 20, alignItems: 'center' }}
      >
        <Image
          source={require('../../../assets/calendar-white.png')}
          style={[
            {
              marginRight: 8,
              resizeMode: 'contain',
            },
            isDesktop()
              ? {
                  width: 26,
                  height: 25,
                }
              : {
                  width: 20,
                  height: 20,
                },
          ]}
        />
        <Text
          style={[
            {
              fontFamily: FONTS.AvenirMedium,

              color: COLORS.BLACK,
              letterSpacing: 1,
            },
            isDesktop()
              ? {
                  fontSize: 18,
                  fontWeight: '600',
                }
              : {
                  fontSize: 17,
                  fontWeight: '700',
                },
          ]}
        >
          {'Select Activity Type and Date:'}
        </Text>
      </View>
      <DropDownSelect
        style={{ marginBottom: 20 }}
        value={filters.activity_type}
        items={activityTypeItems}
        dropDownContainerTextStyle={{ color: COLORS.BLACK }}
        textStyle={{ color: COLORS.GREY }}
        setValues={(value) => {
          setFilters((prev) => {
            return {
              ...prev,
              type_id: value,
            };
          });
        }}
      />
      <View
        style={[
          {
            marginBottom: 15,
            zIndex: 2,
          },
          isDesktop()
            ? {
                flexDirection: 'row',
                justifyContent: 'space-between',
              }
            : {
                flexDirection: 'column',
              },
        ]}
      >
        <View
          style={[
            {
              flexDirection: 'row',
              alignItems: 'center',
              borderRadius: 10,
              overflow: 'hidden',
            },
            isDesktop()
              ? {
                  width: '57%',
                  backgroundColor: '#F5F5F5',
                }
              : {
                  width: '100%',
                  backgroundColor: COLORS.WHITE,
                  marginBottom: 15,
                },
          ]}
        >
          <ActivityTabItem
            active={filterType == 'today'}
            onPress={() => {
              handleChangeTab('today');
            }}
            title="Today"
          />
          <ActivityTabItem
            active={filterType == 'this-week'}
            onPress={() => {
              handleChangeTab('this-week');
            }}
            title="This Week"
          />
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              width: '44%',
              height: isDesktop() ? 45 : '100%',
              backgroundColor:
                filterType === 'month'
                  ? COLORS.RED_PRIMARY
                  : isDesktop()
                  ? COLORS.LIGHT_GREY
                  : COLORS.WHITE,
              borderRadius: 10,
            }}
          >
            <MonthSwitcher
              active={filterType === 'month'}
              onChangeDate={(date) => {
                handleMonthFilter(date);
              }}
            />
          </View>
        </View>
        <InputDatePicker
          date={filterDate}
          onChangeDate={(date) => {
            handleDateFilter(date);
          }}
          inputStyle={{
            width: '100%',
            color: COLORS.GREY,
            borderColor: COLORS.LGREY,
            backgroundColor: COLORS.WHITE,
          }}
          style={{ width: isDesktop() ? '42%' : '100%' }}
          dateFormat={'dddd, MMMM D'}
        />
      </View>
      <View
        style={{
          backgroundColor: COLORS.LIGHT_RED,
          borderRadius: 18,
          paddingTop: 20,
        }}
      >
        {isLoading ? (
          <View
            style={{
              paddingVertical: 20,
            }}
          >
            <Loading />
          </View>
        ) : activityList.length > 0 ? (
          <View
            style={[
              {
                flexWrap: 'wrap',
              },
              isDesktop()
                ? {
                    flexDirection: 'row',
                  }
                : {
                    flexDirection: 'column',
                  },
            ]}
          >
            {activityList.map((activity, index) => (
              <ActivityItem index={index} activity={activity} />
            ))}
          </View>
        ) : (
          <View style={styles.noDataWrapper}>
            <Text style={[styles.noDataText, { fontSize: 18 }]}>
              THERE ARE CURRENTLY NO ACTIVITIES
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  activityTopSubText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 16,
    color: COLORS.BLACK,
    fontWeight: '500',
    width: '45%',
    textAlign: 'right',
  },
  activityContentText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 16,
    color: COLORS.GREY,
    fontWeight: '500',
    marginBottom: 10,
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 20,
    width: '100%',
  },
  noDataText: {
    color: COLORS.BLACK,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirRegular,
    textAlign: 'center',
  },
});
